import { Flex, Spinner, Image } from '@chakra-ui/react';
import Logo from '../assets/musa-logo.svg';

export function Loader() {
    return (
        <Flex
            w="100vw"
            h="100vh"
            bg={{ base: 'musa.offWhite', _dark: 'musa.dark.100' }}
            justifyContent="center"
            alignItems="center"
            flexDirection="column">
            <Image src={Logo} boxSize={40} />
            <Spinner size="xl" />
        </Flex>
    );
}
